<template>
    <Layout :pagetitle="'品牌列表'">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title mb-0">品牌列表</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="mt-4 mt-xl-0">
                                    <h5 class="font-size-14 mb-4">
                                        <i class="mdi mdi-arrow-right text-primary me-1"></i>查詢條件
                                    </h5>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="mb-3">
                                                <label class="form-label" for="name">品牌名稱</label>
                                                <input class="form-control" type="text"
                                                       v-model="searchCondition.name"
                                                       id="name" placeholder="輸入品牌名稱">
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="mb-3">
                                                <label class="form-label" for="companyName">公司名稱</label>
                                                <input class="form-control" type="text"
                                                       v-model="searchCondition.companyName"
                                                       id="companyName" placeholder="輸入公司名稱">
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="mb-3">
                                                <label class="form-label" for="businessId">統一編號</label>
                                                <input class="form-control" type="text"
                                                       v-model="searchCondition.businessId"
                                                       id="businessId" placeholder="輸入統一編號">
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="mb-3">
                                                <label class="form-label" for="primaryOperatorSubject">主要操作人</label>
                                                <input class="form-control" type="text"
                                                       v-model="searchCondition.primaryOperatorSubject"
                                                       id="primaryOperatorSubject" placeholder="輸入帳號或 Subject">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-4">
                                        <div class="hstack gap-3">
                                            <button type="submit" @click.prevent="doSearch"
                                                    class="btn btn-primary w-md">
                                                搜尋
                                            </button>
                                            <div class="vr"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="mt-4 mt-xl-0">
                                    <h5 class="font-size-14 mb-4">
                                        <i class="mdi mdi-arrow-right text-primary me-1"></i>列表
                                    </h5>
                                    <div class="row">
                                        <Grid :style="{ height: '100%' }" :data-items="result" :sortable="true"
                                              :pageable="{ refresh: true, pageSizes: [10, 25, 50, 100], buttonCount: 5 }"
                                              :scrollable="'none'"
                                              :filterable="false" :filter="filter" :sort="sort"
                                              @sortchange="sortChangeHandler" @pagechange="pageChangeHandler"
                                              :skip="skip"
                                              :take="take" :total="total" :columns="columns">
                                            <template v-slot:impersonateCell="{ props }">
                                                <td>
                                                    <button class="btn btn-sm btn-outline-secondary"
                                                            :disabled="impersonateLoadingId === props.dataItem.id"
                                                            @click="openImpersonate(props.dataItem.id)">
                                                        {{ impersonateLoadingId === props.dataItem.id ? '處理中...' : '代看' }}
                                                    </button>
                                                </td>
                                            </template>
                                        </Grid>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading v-model:active="isLoading" :can-cancel="true" :is-full-page="fullPage"/>
    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import {Grid} from "@progress/kendo-vue-grid";
import {toDataSourceRequestString} from "@progress/kendo-data-query";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    mounted: function () {
        this.fetchData({skip: this.skip, take: this.take, filter: this.filter});
    },
    data() {
        return {
            sort: null,
            filter: {
                logic: "and",
                filters: [],
            },
            isLoading: false,
            fullPage: true,
            result: [],
            skip: 0,
            take: 10,
            total: 0,
            impersonateLoadingId: null,
            columns: [
                {field: "id", title: "", hidden: true},
                {field: "name", title: "品牌名稱"},
                {field: "companyName", title: "公司名稱"},
                {field: "businessId", title: "統一編號"},
                {field: "code", title: "品牌代碼"},
                {field: "storeCount", title: "門市數"},
                {field: "operatorCount", title: "操作人數"},
                {field: "primaryOperatorSubject", title: "主要操作人"},
                {field: "operatorSubjectsText", title: "全部操作人"},
                {field: "createTime", title: "建立日期", type: "date", format: "{0: yyyy-MM-dd HH:mm:ss}"},
                {title: "操作", cell: "impersonateCell", filterable: false, sortable: false, width: "100px"},
            ],
            searchCondition: {
                name: "",
                companyName: "",
                businessId: "",
                primaryOperatorSubject: "",
            },
        };
    },
    components: {
        Layout,
        Grid,
        Loading,
    },
    watch: {
        "searchCondition.name": function (newValue) {
            this.setFilter("name", newValue, "contains");
        },
        "searchCondition.companyName": function (newValue) {
            this.setFilter("companyName", newValue, "contains");
        },
        "searchCondition.businessId": function (newValue) {
            this.setFilter("businessId", newValue, "contains");
        },
        "searchCondition.primaryOperatorSubject": function (newValue) {
            this.setFilter("primaryOperatorSubject", newValue, "contains");
        },
    },
    methods: {
        sortChangeHandler: function (e) {
            setTimeout(() => {
                this.sort = e.sort;
                this.fetchData({skip: this.skip, take: this.take, filter: this.filter, sort: this.sort});
            }, 200);
        },
        pageChangeHandler: function (event) {
            setTimeout(() => {
                this.skip = event.page.skip;
                this.take = event.page.take;
                this.fetchData({skip: this.skip, take: this.take, filter: this.filter, sort: this.sort});
            }, 300);
        },
        fetchData: function (dataState) {
            let self = this;
            self.isLoading = true;
            const queryStr = `${toDataSourceRequestString(dataState)}`;
            const baseUrl = "/api/QueryBrand";
            const init = {method: "GET", accept: "application/json", headers: {}};
            fetch(`${baseUrl}?${queryStr}`, init)
                .then((response) => response.json())
                .then(({data, total}) => {
                    this.result = data.map((item) => {
                        return {
                            ...item,
                            operatorSubjectsText: Array.isArray(item.operatorSubjects)
                                ? item.operatorSubjects.join(", ")
                                : "",
                        };
                    });
                    this.total = total;
                    self.isLoading = false;
                })
                .catch(() => {
                    self.isLoading = false;
                });
        },
        setFilter: function (fieldName, newValue, operator) {
            if (newValue !== "") {
                let index = this.filter.filters.findIndex(
                    (x) => x.field === fieldName
                );
                if (index === -1) {
                    this.filter.filters.push({
                        field: fieldName,
                        operator: operator,
                        value: newValue,
                    });
                } else {
                    this.filter.filters[index].value = newValue;
                }
            } else {
                let index = this.filter.filters.findIndex(
                    (x) => x.field === fieldName
                );
                if (index !== -1) {
                    this.filter.filters.splice(index, 1);
                }
            }
        },
        doSearch: function () {
            this.resetPager();
            this.fetchData({skip: this.skip, take: this.take, filter: this.filter, sort: this.sort});
        },
        resetPager: function () {
            this.skip = 0;
            this.take = 10;
        },
        openImpersonate: function (brandId) {
            this.impersonateLoadingId = brandId;
            fetch("/api/ImpersonateBrand", {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({brandId}),
            })
                .then((res) => {
                    if (!res.ok) throw new Error(`代看失敗（${res.status}）`);
                    return res.json();
                })
                .then(({redirectUrl}) => {
                    window.open(redirectUrl, "_blank");
                })
                .catch((err) => {
                    alert(err.message || "代看功能發生錯誤，請稍後再試");
                })
                .finally(() => {
                    this.impersonateLoadingId = null;
                });
        },
    },
};
</script>
